import React from 'react';
import Header from "../../layout/headers/header";
import Sidebar from '../../layout/navigation/sidebar/dynamic-sidebar';
import AllCooperateReceiptsTable from './AllCooperateReceiptsTable';

const AllCooperateReceipts = () => {
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <AllCooperateReceiptsTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AllCooperateReceipts;